// HomeWeb.jsx
import React, { useState, useRef, useEffect } from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform, TouchableWithoutFeedback, TextInput, KeyboardAvoidingView, Alert } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from '../components/baseWeb';
import styles from '../styles/formularios';
import axios from 'axios';
import MaskInput, { Masks } from 'react-native-mask-input'; // Para aplicar máscara no CPF
import { useLogScreen } from '../../useLogScreen';
export default function OneCadastroAnaliseWeb() {
  useLogScreen('OneCadastroAnalise');
  useEffect(() => {
    if (Platform.OS === 'web') {
      setTimeout(() => {
        document.title = 'imoGo | Dados do proprietário';
      }, 100);
    }
  }, []);
  const navigation = useNavigation();
  // envio unico 

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [usuario_id, setUsuario_id] = useState(null);


  console.log(usuario_id)


  // teste multi forms

  const [proprietarios, setProprietarios] = useState([
    {
      nomeCompleto: '', nomeCompletoMae: '', cpf: '', dataNascimento: '', estadoCivil: '',
      conjuge: {
        nomeCompletoCng: '',
        nomeCompletoMaeCng: '',
        cpfCng: '',
        dataNascimentoCng: '',
      },
    },
  ]);


  const adicionarProprietario = () => {
    setProprietarios([...proprietarios, {
      nomeCompleto: '', nomeCompletoMae: '', cpf: '', dataNascimento: '', estadoCivil: '',
      conjuge: {
        nomeCompletoCng: '',
        nomeCompletoMaeCng: '',
        cpfCng: '',
        dataNascimentoCng: '',
      },
    }]);
  };

  const atualizarProprietario = (index, campo, valor, subcampo = null) => {
    const novosProprietarios = [...proprietarios];
    if (subcampo) {
      novosProprietarios[index][campo][subcampo] = valor; // Atualiza subcampo (cônjuge)
    } else {
      novosProprietarios[index][campo] = valor; // Atualiza campo principal
    }
    setProprietarios(novosProprietarios);
  };
  // end teste 

  // Referências para os inputs
  const nomeCompletoRef = useRef([]);
  const nomeCompletoMaeRef = useRef([]);
  const cpfRef = useRef([]);
  const dataNascimentoRef = useRef([]);

  // Estado dos campos
  const [nomeCompleto, setNomeCompleto] = useState('');
  const [nomeCompletoMae, setNomeCompletoMae] = useState('');
  const [cpf, setCpf] = useState('');

  const nomeCompletoCngRef = useRef([]);
  const nomeCompletoMaeCngRef = useRef([]);
  const cpfCngRef = useRef([]);
  const dataNascimentoCngRef = useRef([]);


  // muie 

  const [nomeCompletoCng, setNomeCompletoCng] = useState('');
  const [nomeCompletoMaeCng, setNomeCompletoMaeCng] = useState('');
  const [cpfCng, setCpfCng] = useState('');


  const [estadoCivil, setEstadoCivil] = useState('');
  const [dataNascimento, setdataNascimento] = useState('');
  const [dataNascimentoCng, setdataNascimentoCng] = useState('');


  const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];


  const [showEstadoCivilOptions, setShowEstadoCivilOptions] = useState(
    proprietarios.map(() => false)
  );

  const estadoCivilOptions = ['solteiro(a)', 'casado(a)', 'viúvo(a)', 'divorciado(a)', 'separado(a)'];

  // Função para selecionar uma opção e fechar a lista  

  const toggleEstadoCivilOptions = (index) => {
    const updatedOptions = [...showEstadoCivilOptions];
    updatedOptions[index] = !updatedOptions[index];
    setShowEstadoCivilOptions(updatedOptions);
  };

  const selectEstadoCivil = (index, option) => {
    atualizarProprietario(index, 'estadoCivil', option); // Atualiza o estado civil no proprietário
    toggleEstadoCivilOptions(index); // Fecha a lista de opções
  };

  // data format 

  const convertDateToISO = (dateString) => {
    // Verifica se a data é uma data 
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      throw new Error("Data inválida. O formato esperado é DD/MM/YYYY.");
    }

    const [day, month, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
  };

  // Validação para habilitar o botão "Salvar"
  // const isFormValid = () => nomeCompleto && proprietarios.cpf && estadoCivil && dataNascimento;

  const isFormValid = () => {
    return proprietarios.every((p) =>
      p.nomeCompleto &&
      p.cpf &&
      p.nomeCompletoMae &&
      p.dataNascimento &&
      p.estadoCivil &&
      (p.estadoCivil.toLowerCase() !== 'casado(a)' || (
        p.conjuge.nomeCompletoCng &&
        p.conjuge.nomeCompletoMaeCng &&
        p.conjuge.cpfCng &&
        p.conjuge.dataNascimentoCng
      ))
    );
  };

  const handleSaveImovel = async () => {

    if (isSubmitting) return; // Previne múltiplos cliques
    setIsSubmitting(true);

    try {
      const dadosFormatados = proprietarios.map((p) => {
        const proprietario = {
          nome_completo: p.nomeCompleto,
          nome_mae: p.nomeCompletoMae,
          cpf: p.cpf,
          e_empresa: false,
          data_nascimento: convertDateToISO(p.dataNascimento),
          estado_civil: p.estadoCivil,
        };

        // Adiciona os dados do cônjuge apenas se o estado civil for "Casado"
        if (p.estadoCivil.toLowerCase() === 'casado(a)') {
          proprietario.conjuge = {
            nome_completo: p.conjuge.nomeCompletoCng,
            cpf: p.conjuge.cpfCng,
            nome_mae: p.conjuge.nomeCompletoMaeCng,
            data_nascimento: convertDateToISO(p.conjuge.dataNascimentoCng),
          };
        }

        return proprietario;
      });

      console.log("Dados formatados: ", dadosFormatados);


      const payload = {
        usuario_id,
        proprietarios: dadosFormatados,
      }

      console.log("Payload: ", payload)

      const response = await axios.post('https://analise3.imogo.com.br/analises/etapa1/cpf/', [
        {
          usuario_id,
          proprietarios: dadosFormatados,
        }
      ]);

      console.log("Resposta da API:", response.data);

      if (response.status === 200) {
        console.log("Dados enviados com sucesso")
        const { analise_id } = response.data;
        navigation.navigate('EtapasAnaliseWeb', { usuario_id, analise_id, status: 2 });
      } else {
        throw new Error(`Erro: Código de status ${response.status}`);
      }
      // Alert.alert('Sucesso', 'Dados enviados com sucesso!');
    } catch (error) {
      console.error("Erro ao enviar dados:", error);
      Alert.alert('Erro', 'Não foi possível enviar os dados.');
    }
  };

  return (
    <BaseWeb>
      {(userInfo) => {
        setUsuario_id(userInfo.id)
        return (
          <ScrollView contentContainerStyle={styles.contentMinimal}>
            <View style={styles.formContainer}>
              <Text style={styles.title}>Dados do proprietário</Text>

              {proprietarios.map((proprietario, index) => (
                <View key={index} style={styles.proprietarioContainer}>

                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>Nome Completo</Text>
                    <TouchableWithoutFeedback onPress={() => nomeCompletoRef.current[index]?.focus()}>
                      <View style={styles.inputContainer}>
                        <TextInput
                          ref={(ref) => nomeCompletoRef.current[index] = ref} // Configurando o ref dinâmico
                          allowFontScaling={false}
                          style={styles.areaInput}
                          placeholder="Nome Completo"
                          value={proprietario.nomeCompleto}
                          placeholderTextColor="#A9A9A9"
                          onChangeText={(text) => atualizarProprietario(index, 'nomeCompleto', text)}
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  </View>
                  {/* Nome Completo Mae */}
                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>Nome da Mãe</Text>
                    <TouchableWithoutFeedback onPress={() => nomeCompletoMaeRef.current[index]?.focus()}>
                      <View style={styles.inputContainer}>
                        <TextInput
                          ref={(ref) => nomeCompletoMaeRef.current[index] = ref} // Configurando o ref dinâmico
                          allowFontScaling={false}
                          style={styles.areaInput}
                          placeholder="Nome da Mãe"
                          value={proprietario.nomeCompletoMae}
                          placeholderTextColor="#A9A9A9"
                          onChangeText={(text) => atualizarProprietario(index, 'nomeCompletoMae', text)}
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  </View>

                  {/* CPF com máscara */}
                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>CPF</Text>
                    <TouchableWithoutFeedback onPress={() => cpfRef.current[index]?.focus()}>
                      <View style={styles.inputContainer}>
                        <MaskInput
                          ref={(ref) => cpfRef.current[index] = ref}
                          allowFontScaling={false}
                          style={styles.areaInput}
                          value={proprietario.cpf}
                          onChangeText={(text) => atualizarProprietario(index, 'cpf', text)}
                          mask={Masks.BRL_CPF}
                          placeholderTextColor="#A9A9A9"
                          keyboardType="numeric"
                          placeholder="000.000.000-00"
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  </View>
                  {/* data  com máscara */}
                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>Data de nascimento</Text>
                    <KeyboardAvoidingView behavior="padding" style={{ flex: 1 }}>
                      <TouchableWithoutFeedback onPress={() => dataNascimentoRef.current[index]?.focus()}>
                        <View style={styles.inputContainer}>
                          <MaskInput
                            ref={(ref) => {
                              dataNascimentoRef.current[index] = ref; // Configura o ref dinâmico para o índice atual
                            }}
                            allowFontScaling={false}
                            style={styles.areaInput}
                            value={proprietario.dataNascimento}
                            mask={dateMask}
                            onChangeText={(text) => atualizarProprietario(index, 'dataNascimento', text)} // Corrigido o campo
                            placeholderTextColor="#A9A9A9"
                            keyboardType="numeric"
                            placeholder="00/00/0000"
                          />
                        </View>
                      </TouchableWithoutFeedback>
                    </KeyboardAvoidingView>
                  </View>


                  {/* Estado Civil */}
                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>Estado Civil</Text>
                    <TouchableWithoutFeedback onPress={() => toggleEstadoCivilOptions(index)}>
                      <View style={styles.inputContainer}>
                        <Text allowFontScaling={false} style={styles.areaInput}>
                          {proprietario.estadoCivil || 'Selecionar'}
                        </Text>
                      </View>
                    </TouchableWithoutFeedback>
                    {showEstadoCivilOptions[index] && (
                      <View style={styles.optionsContainer}>
                        {estadoCivilOptions.map((option) => (
                          <TouchableOpacity
                            key={option}
                            style={styles.optionItem}
                            onPress={() => selectEstadoCivil(index, option)} // Passa o índice e a opção selecionada
                          >
                            <Text style={styles.optionText}>{option}</Text>
                          </TouchableOpacity>
                        ))}
                      </View>
                    )}
                  </View>

                  {/* Campos do cônjuge */}
                  {proprietario.estadoCivil === 'casado(a)' && (
                    <>
                      <View style={styles.row}>
                        <Text style={styles.subLabel} allowFontScaling={false}>Nome do Cônjuge</Text>
                        <TouchableWithoutFeedback onPress={() => nomeCompletoCngRef.current[index]?.focus()}>
                          <View style={styles.inputContainer}>
                            <TextInput
                              ref={(ref) => {
                                if (!nomeCompletoCngRef.current[index]) {
                                  nomeCompletoCngRef.current[index] = {};
                                }
                                nomeCompletoCngRef.current[index] = ref; // Configura o ref dinâmico para o índice atual
                              }}
                              allowFontScaling={false}
                              style={styles.areaInput}
                              placeholder="Nome do Cônjuge"
                              value={proprietario.conjuge.nomeCompletoCng}
                              placeholderTextColor="#A9A9A9"
                              onChangeText={(text) => atualizarProprietario(index, 'conjuge', text, 'nomeCompletoCng')}
                            />
                          </View>
                        </TouchableWithoutFeedback>
                      </View>
                      {/* nome mae  */}
                      <View style={styles.row}>
                        <Text style={styles.subLabel} allowFontScaling={false}>Nome da mãe do Cônjuge</Text>
                        <TouchableWithoutFeedback onPress={() => nomeCompletoMaeCngRef.current[index]?.focus()}>
                          <View style={styles.inputContainer}>
                            <TextInput
                              ref={(ref) => {
                                if (!nomeCompletoMaeCngRef.current[index]) {
                                  nomeCompletoMaeCngRef.current[index] = {};
                                }
                                nomeCompletoMaeCngRef.current[index] = ref; // Configura o ref dinâmico para o índice atual
                              }}
                              allowFontScaling={false}
                              style={styles.areaInput}
                              placeholder="Nome do Cônjuge"
                              value={proprietario.conjuge.nomeCompletoMaeCng}
                              placeholderTextColor="#A9A9A9"
                              onChangeText={(text) => atualizarProprietario(index, 'conjuge', text, 'nomeCompletoMaeCng')}
                            />
                          </View>
                        </TouchableWithoutFeedback>
                      </View>
                      {/* cpf */}
                      <View style={styles.row}>
                        <Text style={styles.subLabel} allowFontScaling={false}>CPF do Cônjuge</Text>
                        <TouchableWithoutFeedback onPress={() => cpfCngRef.current[index]?.focus()}>
                          <View style={styles.inputContainer}>
                            <MaskInput
                              ref={(ref) => {
                                if (!cpfCngRef.current[index]) {
                                  cpfCngRef.current[index] = {};
                                }
                                cpfCngRef.current[index] = ref; // Configura o ref dinâmico para o índice atual
                              }}
                              allowFontScaling={false}
                              style={styles.areaInput}
                              value={proprietario.conjuge.cpfCng}
                              onChangeText={(text) => atualizarProprietario(index, 'conjuge', text, 'cpfCng')}
                              mask={Masks.BRL_CPF}
                              placeholderTextColor="#A9A9A9"
                              keyboardType="numeric"
                              placeholder="000.000.000-00"
                            />
                          </View>
                        </TouchableWithoutFeedback>
                      </View>
                      {/* data */}
                      <View style={styles.row}>
                        <Text style={styles.subLabel} allowFontScaling={false}>Data de Nascimento do Cônjuge</Text>
                        <TouchableWithoutFeedback onPress={() => dataNascimentoCngRef.current[index]?.focus()}>
                          <View style={styles.inputContainer}>
                            <MaskInput
                              ref={(ref) => {
                                if (!dataNascimentoCngRef.current[index]) {
                                  dataNascimentoCngRef.current[index] = {};
                                }
                                dataNascimentoCngRef.current[index] = ref; // Configura o ref dinâmico para o índice atual
                              }}
                              allowFontScaling={false}
                              style={styles.areaInput}
                              value={proprietario.conjuge.dataNascimentoCng}
                              onChangeText={(text) => atualizarProprietario(index, 'conjuge', text, 'dataNascimentoCng')}
                              mask={dateMask}
                              placeholderTextColor="#A9A9A9"
                              keyboardType="numeric"
                              placeholder="00/00/0000"
                            />
                          </View>
                        </TouchableWithoutFeedback>
                      </View>


                    </>
                  )}

                  {/* Separador visual (Divisão) */}
                  <View style={styles.divider} />


                </View>
              ))}

              {/* Inputs de Área */}

              <TouchableOpacity style={styles.laterButton} onPress={adicionarProprietario}>
                <Text style={styles.laterButtonText}>Adicionar mais proprietário</Text>
              </TouchableOpacity>
              {/* Botão Salvar */}
              <View style={styles.buttonContainer}>
                <TouchableOpacity
                  style={[
                    styles.saveButton,
                    (!isFormValid() || isSubmitting) && { backgroundColor: '#ccc' },
                  ]}
                  onPress={handleSaveImovel}
                  disabled={!isFormValid() || isSubmitting} // Desabilita durante a submissão
                >
                  <Text style={styles.saveButtonText} allowFontScaling={false}>
                    {isSubmitting ? "Enviando..." : "Salvar"}
                  </Text>
                </TouchableOpacity>

                {/* <TouchableOpacity style={styles.laterButton}>
                  <Image
                    source={require('../../assets/icons/bookmark.png')} // Ícone de terminar mais tarde
                    style={styles.laterIcon}
                  />
                  <Text
                    style={styles.laterButtonText}
                    allowFontScaling={false}
                    onPress={() => navigation.navigate('Home', { usuario_id })}
                  >
                    Terminar mais tarde
                  </Text>
                </TouchableOpacity> */}
              </View>

            </View>
          </ScrollView>
        );
      }}
    </BaseWeb>
  );
}
